import {Inject, Injectable} from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private msalService: MsalService) {
  }

  public getUsername() {
    const account = this.msalService.instance.getActiveAccount();
    if (account == undefined || account == null) {
      return null;
    }

    var claims = account.idTokenClaims;
    if (claims == undefined || claims == null) {
      return null;
    }

    return claims['ManagedUsername'] as string;
  }

  public getFirstName() {
    const account = this.msalService.instance.getActiveAccount();
    if (account == undefined || account == null) {
      return null;
    }

    var claims = account.idTokenClaims;
    if (claims == undefined || claims == null) {
      return null;
    }

    return claims.name?.split(', ')[1]!;
  }

  public getLastName() {
    const account = this.msalService.instance.getActiveAccount();
    if (account == undefined || account == null) {
      return null;
    }

    var claims = account.idTokenClaims;
    if (claims == undefined || claims == null) {
      return null;
    }

    return claims.name?.split(', ')[0]!;
  }
}
